import { language as lan_cartList } from "./list";
import { language as lan_cartCoupon } from "./coupon";
import { language as lan_cartProgressbar } from "./progressbar";

let language = {
    ...lan_cartList,
    ...lan_cartCoupon,
    ...lan_cartProgressbar,

    A105B001: "Are you sure you want to delete this cart item? Click [OK] to remove the item, or click [Cancel] to cancel the deletion.",
    A105B002: "Delete Cart Item",
    CARTITEM_QTY_TIP_TITLE: "Purchase Quantity Limit",
    CARTITEM_QTY_TIP_TEXT: "Oops, {{qtyTip}}",
    CART_ISSUE_PAGE_LOADING_TITLE: "Cart Page Loading Issue",
    CART_ERROE_PAGE_LOADING_TITLE: "Cart Page Loading Error",
    CART_ISSUE_PAGE_LOADING_CONTENT: "An issue occurred while loading this page. Please refresh the page and try again. If the problem persists, feel free to contact our support team at {{supportmail}}.",
    CART_ITEM_PRICE_UPDATE_ISSUE_TITLE: "Cart Product Update Issue",
    CART_ITEM_PRICE_UPDATE_ERROE_TITLE: "Cart Product Update Error",
    CART_ITEM_PRICE_UPDATE_ISSUE_CONTENT: "An issue occurred while updating cart items price. Please refresh the page and try again. If the problem persists, feel free to contact our support team at {{supportmail}}.",
    CART_ITEM_QTY_UPDATE_ISSUE_TITLE: "Quantity Update Issue",
    CART_ITEM_QTY_UPDATE_ERROR_TITLE: "Quantity Update Error",
    CART_ITEM_QTY_UPDATE_ISSUE_CONTENT: "An issue occurred while updating cart item purchase quantity. Please refresh the page and try again. If the problem persists, feel free to contact our support team at {{supportmail}}.",
    CART_CURRENCY_CONFIG_MISSING_CONTENT:"There is an error with the {{appName}} currency setting. Please refresh the page and click \"{{updateCurrencyBtn}}\" to update {{appName}} display currency. If issues still persist, please contact {{serviceEmail}}.",
    CART_CURRENCY_NONSUPPORT_CONTENT:"The currency you selected is not supported. Please click \"{{updateCurrencyBtn}}\" to update {{appName}} display currency.",
    A105B300310:"The currency {{currentCurrency}} does not exist in the system.",
    A105B3000601: "The current currency: {{currentCurrency}}, supported currency types on the {{appName}} platform: {{supportCurrencies}}",
}

export { language }
